import axios from "axios";

const client = axios.create({
    baseURL: import.meta.env.VITE_ANALYTICS_ENDPOINT,
});

export const createWebLogRecord = async (
    sessionId,
    entityId,
    detail,
    errorPresent,
    completed,
    recordStepCode
) => {
    try {
        const { data } = await client.post(`/webLogRecord`, {
            sessionId,
            entityId,
            detail,
            completed,
            errorPresent,
            recordStepCode,
            origin: 'Belozmexico'
        });
        return data;
    } catch (error) {
        console.error('analytics error ', error?.response?.data);
        return { success: false };
    }
};